export enum BrowserPlatForm {
  MAC = 'Mac',
  WINDOWS = 'Win',
  LINUX = 'Linux',
}
